var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('practice-request-sent'),_c('practice-upcoming-bookings'),_c('practice-booking-history'),_c('practice-applications-received'),_c('practice-created-offers')],1)}
var staticRenderFns = []

export { render, staticRenderFns }